import { useSelector } from "react-redux";

import { getManifestSelector } from "../contextualSelectors/index.ts";

export const useGetManifest = () => useSelector(getManifestSelector);
